import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import actions from "./favorite-filter-actions.store";
import getters from "./favourite-filter-getters.store";
import mutations from "./favourite-filter-mutations.store";
import {
  IFavouriteFilterState,
  FavouriteFilterState
} from "./favourite-filter-states.store";
import { FavouriteFilterServices } from "../../services/favourites-filter.services";

export class FavouriteFilterModule<RootState>
  implements Module<IFavouriteFilterState, RootState> {
  namespaced: boolean;
  state: IFavouriteFilterState;
  getters: GetterTree<IFavouriteFilterState, RootState>;
  actions: ActionTree<IFavouriteFilterState, RootState>;
  mutations: MutationTree<IFavouriteFilterState>;
  /**
   *
   */
  constructor() {
    this.namespaced = true;
    this.state = new FavouriteFilterState({
      service: new FavouriteFilterServices()
    });
    this.mutations = mutations;
    this.actions = actions;
    this.getters = getters;
  }
}
